import { useLazyQuery, useMutation } from '@apollo/client';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import MaterialsContainer from '../../components/MaterialsContainer/MaterialsConatiner';
import PDFViewer from '../../components/PDFViewer/PDFViewer';
import FileUpload from '../../components/Popups/FileUpload';
import './TeacherTeachingMaterial.scss';
import { useCallback, useEffect, useState } from 'react';
import { CONVERT_PPT_DOCS_TO_PDF, DELETE_EBOOK_MATERIAL, DELETE_EBOOK_MATERIAL_ADMIN, UPDATE_EBOOK_MATERIAL, UPDATE_EBOOK_MATERIAL_ADMIN, UPLOAD_MATERIAL, UPLOAD_MATERIAL_ADMIN, VIEW_ALL_EBOOK_MATERIAL, VIEW_ALL_MATERIAL_ADMIN } from './api/TeacherTeachingMaterialQuery';
import ToasterWithMessage from '../../components/toaster';
import { useLocation, useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import Loader from '../../components/Loader/Loader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import { useAppSelector } from '../../redux/app/hooks';
import { materialsData } from '../../utils/interface';
import { FETCH_POLICY, MATERIALS_TEXT, PATH_ADDRESSES, SCHOOL_ADMIN, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR } from '../../utils/constants';
import FileViewer from '../../components/FileViewer/FileViewer';
import CsvViewer from '../../components/CsvViewer/CsvViewer';
import EpubFileViewer from '../../components/EpubFileViewer/EpubFileViewer';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import images from '../../assets/images';
import { getFileViewerType, getScreenDimensions } from '../../utils/helper';
import { EDIT_MYLIBRARY_MATERIALS } from '../ImageMaterial/api/ImageMaterialQuery';
import CommonBulkUpload, { BulkFileState } from '../../components/Popups/CommonBulkUpload/CommonBulkUpload';
import { UploadedFilePayload } from '../SyndicatedVideos/SyndicatedVideos';
import UploadResultModal, { UploadResult, UploadResultForTeacher } from '../AdminBulkUpload/components/UploadResultModal';

const TeacherTeachingMaterial = () => {
    const { uploadCloud } = images;
    const [url, setUrl] = useState<string>();
    const [pdfFileData, setPdfFileData] = useState<materialsData | undefined>();
    const [filename, setFilename] = useState<string>();
    const [fileData, setFileData] = useState<File | null>();
    const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [openPdf, setOpenPdf] = useState(false);
    const [materialsData, setMaterialsData] = useState<[materialsData]>();
    const [searchValue, setSearchValue] = useState<string>('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadFailed, setUploadFailed] = useState<boolean>(false);
    const [uploadFileName, setUploadFileName] = useState<string>('');
    const [materialAction,setMaterialAction] = useState<string>('');
    const [uploaded, setuploaded] = useState(false);
    const { success, error } = ToasterWithMessage();
    const { state } = useLocation();
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const role = useAppSelector((state) => state.auth.role);
    const backNavigation = role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials" :role === STUDENT_ROLE ? '/student-classroom/ebooks/materials' : '/teacher-classroom/ebooks/materials';
    const navigate = useNavigate();
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const selectedClassroomIdAdmin = useAppSelector(
        (state) => state.CommonUpload.classroomId
      );
    const [isEditTeachingMaterial, setIsEditTeachingMaterial] = useState<boolean>(false);
    const [hasSubmittedForEdit, setHasSubmittedForEdit] = useState<boolean>(false);

    const [FilesStatusData, setFilesStatusData] = useState<Array<BulkFileState>>([]);
    const [uploadedPayloads, setUploadedPayloads] = useState<UploadedFilePayload[]>([]);
    const [totalProgress, setTotalProgress] = useState<number>(0);
    const [successCount, setSuccessCount] = useState<number>(0);
    const [failureCount, setFailureCount] = useState<number>(0);
    const [uploadResults, setUploadResults] = useState<UploadResult[]>([]);
    const [upoloadResultsForTeacher, setUploadResultsForTeacher] = useState<UploadResultForTeacher>();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [editTeachingMaterial] = useMutation(EDIT_MYLIBRARY_MATERIALS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            console.log("edit teaching material data",data);
           if(data?.editMylibraryEbookMaterial) {
                setFileData(null);
                if(!(fileData && url)) {
                    success("File updated successfully!");
                }
                if(fileData && url) {
                    if (filename) {
                        setUploadFileName(filename);
                    }
                    setuploaded(true);
                    setUploadProgress(100);
                }
                setFilename('');
                setUrl('');
                setHasSubmittedForEdit(false);
                setMaterialAction('');
                if(role === SCHOOL_ADMIN){
                  getAllTeachingMaterialForAdmin({
                    variables: {
                      typeName: MATERIALS_TEXT,
                      subjectId: selectedSubjectId,
                      searchInput: `%${searchValue.trim()}%`,
                      classroomIds : [selectedClassroomIdAdmin]

                    },
                  });
                } else {
                    getAllTeachingMaterial({
                        variables: {
                            lId: selectedLibraryId,
                            sjId: selectedSubjectId,
                            type: MATERIALS_TEXT,
                            cId: selectedClassRoomId,
                            limit: null,
                            offset: null,
                            searchInput: `%${searchValue.trim()}%`,
                            orderByColumn: null,
                            orderByDirection: null,
                            isclassroom: role === STUDENT_ROLE ? true : [true, false],
                        }
                    });
                  }
           }
        },
        onError: (err) => {
            error(err?.message);
            if (filename) {
                setUploadFileName(filename);
            }
            if(fileData && url) {
                setuploaded(true);
                setUploadProgress(0);
                setUploadFailed(true);
            }
        }
    });
    
    const [uploadTeachingMaterial] = useMutation(UPLOAD_MATERIAL, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadMultipleMylibraryEbookMaterials?.json) {
                setUploadedPayloads([]);
                const result = data?.uploadMultipleMylibraryEbookMaterials?.json || {};
                setUploadResultsForTeacher(result);

                const hasFailures =
                result.failed_count > 0 ||
                result.results.some((item: any) => item.status === "error");

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }
                
                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                getAllTeachingMaterial({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: MATERIALS_TEXT,
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: `%${searchValue.trim()}%`,
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                });
            }
        },
        onError: (err) => {
            setUploadedPayloads([]);
            // error(err?.message);
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });


     const [uploadTeachingMaterialAdmin] = useMutation(UPLOAD_MATERIAL_ADMIN, {
       fetchPolicy: FETCH_POLICY,
       onCompleted: (data) => {
         if (data?.uploadMylibraryEbooksBySchoolAdmin) {
                setUploadedPayloads([]);

                const result = data.uploadMylibraryEbooksBySchoolAdmin?.result || [];

                setUploadResults(result);

                const hasFailures = result.some(
                    (res: UploadResult) => res.classrooms_failed.length > 0
                );

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }

           setFileData(null);
           if (filename) {
             setUploadFileName(filename);
           }
           setuploaded(true);
           setUploadProgress(100);
           setFilename("");
           setUrl("");
           getAllTeachingMaterialForAdmin({
             variables: {
               typeName: MATERIALS_TEXT,
               subjectId: selectedSubjectId,
               searchInput: `%${searchValue.trim()}%`,
                                classroomIds : [selectedClassroomIdAdmin]

             },
           });
         }
       },
       onError: (err) => {
         setUploadedPayloads([]);
         error(err?.message);
         if (filename) {
           setUploadFileName(filename);
         }
         setuploaded(true);
         setUploadProgress(0);
         setUploadFailed(true);
         console.error(err?.message)
       },
     });

    
    const [updateTeachingMaterial] = useMutation(UPDATE_EBOOK_MATERIAL, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.updateEbookMaterials) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                getAllTeachingMaterial({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: MATERIALS_TEXT,
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: `%${searchValue.trim()}%`,
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                });
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });


    const [updateTeachingMaterialAdmin] = useMutation(UPDATE_EBOOK_MATERIAL_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.updateEbookMaterialsBySchoolAdmin) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                getAllTeachingMaterialForAdmin({
                  variables: {
                    typeName: MATERIALS_TEXT,
                    subjectId: selectedSubjectId,
                    searchInput: `%${searchValue.trim()}%`,
                                     classroomIds : [selectedClassroomIdAdmin]

                  },
                });
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    const [deleteTeachingMaterial] = useMutation(DELETE_EBOOK_MATERIAL, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.deleteEbookMaterials) {
                success("Deleted successfully");
                getAllTeachingMaterial({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: MATERIALS_TEXT,
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: `%${searchValue.trim()}%`,
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                });
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [deleteTeachingMaterialAdmin] = useMutation(DELETE_EBOOK_MATERIAL_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.deleteEbookMaterialsBySchoolAdmin) {
                success("Deleted successfully");
                getAllTeachingMaterialForAdmin({
                  variables: {
                    typeName: MATERIALS_TEXT,
                    subjectId: selectedSubjectId,
                    searchInput: `%${searchValue.trim()}%`,
                                     classroomIds : [selectedClassroomIdAdmin]

                  },
                });
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    const [getAllTeachingMaterial, { loading }] = useLazyQuery(VIEW_ALL_EBOOK_MATERIAL, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.getMaterialsFromEbookType?.nodes) {
                setMaterialsData(data?.getMaterialsFromEbookType?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });


    const [getAllTeachingMaterialForAdmin, {loading : AdminLoading } ] = useLazyQuery(VIEW_ALL_MATERIAL_ADMIN, {
    fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.getMylibraryEbooksForAdmin?.nodes) {
                setMaterialsData(data?.getMylibraryEbooksForAdmin?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    }) 

    const [convertPptDocToPdf, { loading: convertLoading }] = useLazyQuery(CONVERT_PPT_DOCS_TO_PDF, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            console.log('CONVERT_PPT_DOCS_TO_PDF response========>',data);
        },
        onError: (err) => {
            error(err?.message);
            // setuploaded(true);
            // setUploadProgress(0);
            // setUploadFailed(true);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })
    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(materialsData && materialsData.length > 0){
        materialsData?.forEach((data) => {
          if (data.feedId) {
            readFeed({
              variables: {
                fId: data.feedId,
                uId: profile?.getCurrentUser?.nodes[0]?.uId
              }
            })
          }
        });
      }
    }
      },[materialsData, profile?.getCurrentUser?.nodes, readFeed, role])

    useEffect(() => {
      if (role === SCHOOL_ADMIN) {
        getAllTeachingMaterialForAdmin({
          variables: {
            typeName: MATERIALS_TEXT,
            subjectId: selectedSubjectId,
            searchInput: "%%",
            classroomIds : [selectedClassroomIdAdmin]
          },
        });
      }else{
      getAllTeachingMaterial({
        variables: {
          lId: selectedLibraryId,
          sjId: selectedSubjectId,
          type: MATERIALS_TEXT,
          cId:selectedClassRoomId,
          limit: null,
          offset: null,
          searchInput: "%%",
          orderByColumn: null,
          orderByDirection: null,
          isclassroom: role === STUDENT_ROLE ? true : [true, false],
        },
      });
    }
    }, []);

    useEffect(() => {
        if (materialAction === 'edit' && (hasSubmittedForEdit)) {
          console.log("ready to call the edit api", fileData, filename, url);
            let newFileName;
            let newFilePath;
            let newFileSize;
            let newFileType;

            if(filename !== pdfFileData?.filename){
                newFileName = filename?.replace(/\.pdf$/, "")?.trim();
            }
            if(fileData){
              newFileType = fileData?.type === "application/pdf"
                      ? "pdf"
                      : fileData?.type === "text/csv"
                      ? "csv"
                      : fileData?.type ===
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      ? "xlsx"
                      : fileData?.type === "application/vnd.ms-excel"
                      ? "xls"
                      : fileData?.type === "application/vnd.ms-powerpoint"
                      ? "ppt"
                      : fileData?.type ===
                        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
                      ? "pptx"
                      : fileData?.type === "application/epub+zip"
                      ? "epub"
                      : fileData?.type === "application/msword"
                      ? "doc"
                      : fileData?.type ===
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      ? "docx"
                      : null
            }
            if(url && fileData) {
                const parts = url.split('.');
                const extension = parts.length > 1 ? parts.pop() : undefined;
                if (extension && ['doc', 'docx', 'ppt', 'pptx'].includes(extension.toLowerCase())) {
                  // Convert documents or PowerPoint files to PDF
                    convertPptDocToPdf({
                        variables: {
                            key: url
                        }
                    }).catch(error => {
                        error(error);
                        console.error("Error during conversion or upload:", error);
                    });
                }
                newFilePath = url;
                newFileSize = fileData?.size;
            }


            editTeachingMaterial({
                variables: {
                    fileId: pdfFileData?.fileId,
                    classroomId: (role === SCHOOL_ADMIN) ? [selectedClassroomIdAdmin] : selectedClassRoomId,
                    subjectId: selectedSubjectId,
                    typeName: MATERIALS_TEXT,
                    ...(newFileName && { newFilename: newFileName }),
                    ...(newFilePath && newFileSize && { newFilepath: newFilePath }),
                    ...(newFilePath && newFileSize && { newFilesize: newFileSize }),
                    ...(newFileType && { newFiletype: newFileType }),
                }
            });
        }
    }, [fileData, filename, url]);

    const formatUploadedPayloads = (
        uploadedPayloads: UploadedFilePayload[]
    ) => {
          return uploadedPayloads.map((item) => {
            return {
                filename: item.filename?.replace(/\.pdf$/, "")?.trim(),
                filepath: item.filepath,
                filesize: item.filesize,
                isClassroom: false,
                filetype: item?.filetype,
                ...((role === SCHOOL_ADMIN) && {
                coverImagePath: null,
                authorName: null}),
            };
            });
    };


    const maybeConvertFile = async (filepath: string) => {
      const ext:any = filepath.split(".").pop()?.toLowerCase();

      if (["doc", "docx", "ppt", "pptx"].includes(ext)) {
        try {
          await convertPptDocToPdf({ variables: { key: filepath } });
          // You might return the new PDF URL if API responds with it
        } catch (err) {
          console.error("Conversion failed:", err);
        }
      }
    };

        
    useEffect(() => {
        const uploadMultiMaterials = async () => {
            if(uploadedPayloads.length > 0 ){
                for (const item of uploadedPayloads) {
                  await maybeConvertFile(item.filepath);
                }

                const updatedFormattedPayload = formatUploadedPayloads(uploadedPayloads);
                if (role === SCHOOL_ADMIN) {
                 uploadTeachingMaterialAdmin({
                   variables: {
                      typeName: MATERIALS_TEXT,
                      subjectId: selectedSubjectId,
                      classroomIds: [selectedClassroomIdAdmin],
                      files: updatedFormattedPayload
                   },
                 });
                } else {
                  uploadTeachingMaterial({
                    variables: {
                      libraryId: selectedLibraryId,
                      subjectId: selectedSubjectId,
                      classroomId: selectedClassRoomId,
                      typeName: MATERIALS_TEXT,
                      files: updatedFormattedPayload
                    },
                  });
                }
            }
        }
        uploadMultiMaterials();
    }, [ uploadedPayloads ]);

    const handleOpenFile = (pdfData: materialsData) => {
        setOpenPdf(true);
        setPdfFileData(pdfData);
    }

    //To close pdf detailed view
    const handleClosePdf = () => {
        setOpenPdf(false);
        setPdfFileData(undefined);
        if(role === SCHOOL_ADMIN){
        getAllTeachingMaterialForAdmin({
          variables: {
            typeName: MATERIALS_TEXT,
            subjectId: selectedSubjectId,
            searchInput: `%${searchValue.trim()}%`,
                             classroomIds : [selectedClassroomIdAdmin]

          },
        });
        }else{
        getAllTeachingMaterial({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                type: MATERIALS_TEXT,
                cId: selectedClassRoomId,
                limit: null,
                offset: null,
                searchInput: `%${searchValue.trim()}%`,
                orderByColumn: null,
                orderByDirection: null,
                isclassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        });
    }
    }

    //To done actions in materials
    const handleMaterialActions = (data:materialsData,action:string) =>{
        if(action === "share"){
            setMaterialAction("share");
            if(role === SCHOOL_ADMIN){
              updateTeachingMaterialAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: true,
                    pTypeName: MATERIALS_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updateTeachingMaterial({
                variables:{
                    isClassroom: true,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: MATERIALS_TEXT,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
           }
        }else if(action === "undoShare"){
            setMaterialAction("undoShare");
            if(role === SCHOOL_ADMIN){
              updateTeachingMaterialAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: false,
                    pTypeName: MATERIALS_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updateTeachingMaterial({
                variables:{
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: MATERIALS_TEXT,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
            }
        }else if(action === "delete"){
            setMaterialAction('');
            if(role === SCHOOL_ADMIN){
              deleteTeachingMaterialAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pTypeName: MATERIALS_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            deleteTeachingMaterial({
                variables:{
                    cId: selectedClassRoomId,
                    fId: data?.fileId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: MATERIALS_TEXT
                }
            })
           }
        } else if(action === "edit"){
            setMaterialAction("edit");
            setIsEditTeachingMaterial(true);
            setOpen(true);
            setIsUploadOpen(true);
            setPdfFileData(data);
        }
    };

    const handleSearchDebounce = useCallback(
        debounce((value) => {
        setSearchValue(value);
        if(role === SCHOOL_ADMIN){
            getAllTeachingMaterialForAdmin({
            variables: {
            typeName: MATERIALS_TEXT,
            subjectId: selectedSubjectId,
            searchInput: `%${value.trim()}%`,
                             classroomIds : [selectedClassroomIdAdmin]

          },
        });
        }else{
            getAllTeachingMaterial({
                variables: {
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: MATERIALS_TEXT,
                    cId: selectedClassRoomId,
                    limit: null,
                    offset: null,
                    searchInput: `%${value.trim()}%`,
                    orderByColumn: null,
                    orderByDirection: null,
                    isclassroom: role === STUDENT_ROLE ? true : [true, false],
                }
            });
        }
        }, 500),
        [getAllTeachingMaterial]
    );
    
    //To open upload popup
    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setOpen(true);
    };

    return (
        <div className={`teacherTeachingMaterial ${role === SCHOOL_ADMIN ? "schoolAdminMaterials":""}`}>
            <LibraryHeader
                image={state?.imageSrc}
                backgroundColor={state?.backGroundColor}
                subject={state?.title}
                subCategory={role === SCHOOL_ADMIN ? `Learning Materials` : role === STUDENT_ROLE ?'My Learning Materials' : 'My Teaching Materials'}
                setIsUploadOpen={setIsUploadOpen}
                openPdf={openPdf}
                onClose={handleClosePdf}
                setOpen={setOpen}
                backNavigation={{ path: backNavigation, state: state }}
                handleSearchDebounce={handleSearchDebounce}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
            />
            {
                openPdf ? (
                    pdfFileData?.filetype === "pdf" ? 
                      <PDFViewer file={pdfFileData?.filepath ? baseUrl + pdfFileData?.filepath : ''} pdfFileData={pdfFileData} onClose={handleClosePdf} type={"Teaching Material"} />
                    // : pdfFileData?.filetype === "csv" ? 
                    //     <div className='excelOuterContainer'>
                    //         <CsvViewer fileUrl={pdfFileData?.filepath ? baseUrl + pdfFileData?.filepath : ''} fileData={pdfFileData} onClose={handleClosePdf}/>
                    //     </div>
                    : (pdfFileData?.filetype === "doc" || pdfFileData?.filetype === "docx" || pdfFileData?.filetype === "ppt" || pdfFileData?.filetype === "pptx" || pdfFileData?.filetype === "xls" || pdfFileData?.filetype === "xlsx") ?
                      <div className='excelOuterContainer'>
                            <FileViewer fileUrl={pdfFileData?.filepath ? baseUrl + pdfFileData?.filepath : ''} fileData={pdfFileData} onClose={handleClosePdf} fileType={getFileViewerType(pdfFileData?.filetype)}/>
                      </div>
                    : (pdfFileData?.filetype === "csv") ? 
                        <div className='excelOuterContainer'>
                            <CsvViewer fileUrl={baseUrl + pdfFileData?.filepath} fileData={pdfFileData} onClose={handleClosePdf} />                       
                        </div>
                    : (pdfFileData?.filetype === "epub") ?
                        <div className='excelOuterContainer'>
                            <EpubFileViewer fileUrl={pdfFileData?.filepath ? baseUrl + pdfFileData?.filepath : ''} fileData={pdfFileData} />
                        </div>
                    : <></>
                    )
                    :
                    <>
                        <div className='teacherTeachingMaterialBody' style={{height: role=== STUDENT_ROLE ? '91%':''}}>
                            {
                                loading || AdminLoading ? <Loader bottom='110px' />
                                    :
                                    <MaterialsContainer
                                        subject={state?.title}
                                        subCategory={`Ebooks/My Learning Materials`}
                                        materialsData={materialsData}
                                        handleOpenFile={handleOpenFile}
                                        handleMaterialActions={handleMaterialActions}
                                    />
                            }
                        </div>
                        
                        {/* {role !== STUDENT_ROLE && <div className='libraryUploadButtonMobile' onClick={handleOpenUpload}>
                            <img src={uploadCloud} alt="upload" className='uploadImage' />
                        </div>} */}
                    </>
            }
            {isUploadOpen && !isEditTeachingMaterial && <CommonBulkUpload page="Teacher Teaching Material" type='teachingMaterials' name={MATERIALS_TEXT} setUploadedPayloads = {setUploadedPayloads} setFilesStatusData = {setFilesStatusData} setTotalProgress = {setTotalProgress} setSuccessCount = {setSuccessCount} setFailureCount = {setFailureCount} setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName}/>}
            {isUploadOpen && isEditTeachingMaterial && pdfFileData && <FileUpload page="Teacher Teaching Material" type='teachingMaterials' setHasSubmittedForEdit={setHasSubmittedForEdit} setMaterialAction={setMaterialAction} selectedFileData = {pdfFileData} isEdit = {isEditTeachingMaterial} setIsEdit = {setIsEditTeachingMaterial} name={MATERIALS_TEXT} setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName}/>}
            {/* {uploaded && <UploadToaster uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />} */}

            {uploaded && <UploadToaster successCount = {successCount} failureCount={failureCount} FilesStatusData = {FilesStatusData} setFilesStatusData = {setFilesStatusData} totalProgress = {totalProgress} setTotalProgress = {setTotalProgress} uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />}

            <UploadResultModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                results={uploadResults}
                uploadResultsForTeacher = {upoloadResultsForTeacher}
                page='teacherMaterialDirectClass'
            />
            {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !openPdf &&
                <div className='libraryHeaderUploadContainer'> 
                    <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                        <img src={uploadCloud} alt="upload" className='uploadImage' />
                    </div>
                </div>}
        </div>
    )
}

export default TeacherTeachingMaterial;
